
import React from "react";
import Carousel from "react-material-ui-carousel";
import { Box, Card, useTheme, useMediaQuery } from "@mui/material";
import { getResponsiveSize, getResponsiveHeight } from "../../utils/responsive";
import globalStyles from "../../global";

const testimonials = [
  {
    name: "Hannah Schmitt, UClean Vasant Owner",
    avatar: "https://via.placeholder.com/80", // replace with an actual image
    quote:
      "For someone who has a young daughter, a clean home is an absolute necessity for me. I started with UClean as my laundry & dry cleaning service provider. But they wowed me with their excellent service, and now they are my one-stop shop for cleaning requirements. I am a customer for life."
  },
  {
    name: "John Doe, UClean Another Location",
    avatar: "https://via.placeholder.com/80",
    quote:
      "From day one, UClean has been a great partner. Their technology and support make running my own franchise a breeze."
  },
  {
    name: "Jane Smith, UClean Yet Another Location",
    avatar: "https://via.placeholder.com/80",
    quote:
      "UClean has truly redefined laundry services worldwide. Being a franchise partner has allowed me to expand my business with confidence."
  }
];

function ImageCarousel() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return (
    <Box sx={{ backgroundColor: globalStyles.colors.white }}>
      <Box
        sx={{
          maxWidth: isSmallScreen ? "90%" : isMediumScreen ? "75%" : "62%",
          margin: "0 auto",
          textAlign: "center",
          padding: theme.spacing(4),
        }}
      >
        <Carousel
          autoPlay={false}
          navButtonsAlwaysVisible
          swipe={true}
          animation="slide"
          sx={{ marginTop: getResponsiveSize(6) }}
        >
          {testimonials.map((item, index) => (
           <Card
           key={index}
           elevation={2}
           sx={{
             py: getResponsiveSize(3),
             px: getResponsiveSize(2),
             display: "flex",
             flexDirection: "column",
             alignItems: "center",
             maxWidth: isSmallScreen ? "95%" : "80%",
             margin: "auto",
             height: isSmallScreen ? getResponsiveSize(407) : getResponsiveHeight(407),
             width: isSmallScreen ? getResponsiveSize(576) : getResponsiveSize(576),
             borderRadius: isSmallScreen ? getResponsiveSize(10) : getResponsiveSize(10),
             backgroundImage: `url('/franchise.png')`,  // Add this line
             backgroundSize: 'cover',                   // Add this line
             backgroundPosition: 'center',              // Add this line
             backgroundRepeat: 'no-repeat'             // Add this line
           }}
         >
         </Card>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
}


export default ImageCarousel;
